var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 105C84.8528 105 105 84.8528 105 60C105 35.1472 84.8528 15 60 15C35.1472 15 15 35.1472 15 60C15 84.8528 35.1472 105 60 105Z",
    fill: "#1AAB9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7836 81.1125C53.3961 81.1125 52.3086 80.0625 52.3086 78.75V59.8875L31.9461 45.825V78.75C31.9461 80.0625 30.8586 81.1125 29.4711 81.1125C28.0836 81.1125 26.9961 80.0625 26.9961 78.75V41.25C26.9961 39.9375 28.0836 38.8875 29.4711 38.8875C29.9961 38.8875 30.4836 39.0375 30.8961 39.3375L56.2086 56.85C56.8461 57.2625 57.2586 57.975 57.2586 58.7625V78.825C57.2586 80.0625 56.1336 81.1125 54.7836 81.1125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2094 81.1125C63.8219 81.1125 62.7344 80.0625 62.7344 78.75V58.725C62.7344 57.975 63.1469 57.225 63.7844 56.8125L89.0594 39.3375C89.4719 39.0375 89.9594 38.8875 90.4844 38.8875C91.6844 38.8875 92.9594 39.7875 92.9594 41.25V78.75C92.9594 80.0625 91.8719 81.1125 90.4844 81.1125C89.0969 81.1125 88.0094 80.0625 88.0094 78.75V45.825L67.6844 59.8875V78.75C67.6844 80.0625 66.5594 81.1125 65.2094 81.1125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaker);
export default __webpack_public_path__ + "static/media/maker.8ec54fcab091e95734da911dc5752eec.svg";
export { ForwardRef as ReactComponent };